//CUSTOM T+C CHECKBOX FUNCTIONALITY


function validateCheckout(){
	if(!document.getElementById('agree').checked){
    	document.getElementById('checkout-agree-error').style.display = "";
	    return false;
    }else{
		return true;
    }
};

var checkbox = document.getElementById('agree');

if(checkbox){
  checkbox.addEventListener('change', function() {
    if (this.checked) {
      document.getElementById('checkout-agree-error').style.display = "none";
    };
  });
};